import type {VelaRule} from '../engine/types';
import {chatRules} from './chat.rules';
import {checkoutRules} from './checkout.rules';
import {depositRules} from './deposit.rules';
import {esimRules} from './esim.rules';
import {guestFormRules} from './guestForm.rules';
import {ivRules} from './iv.rules';
import {registrationRules} from './registration.rules';
import {remoteAccessRules} from './remoteAccess.rules';
import {paymentsRules} from './payments.rules';
import {taxesRules} from './taxes.rules';
import {travelGuideRules} from './travelGuide.rules';
import {upsellingRules} from './upselling.rules';

export const velaRules: VelaRule[] = [
  ...registrationRules,
  ...guestFormRules,
  ...ivRules,
  ...remoteAccessRules,
  ...taxesRules,
  ...depositRules,
  ...paymentsRules,
  ...upsellingRules,
  ...chatRules,
  ...esimRules,
  ...checkoutRules,
  ...travelGuideRules,
];
